export default __webpack_public_path__ + "static/media/local-capital.2da38b14.jpg";